import { Injectable } from "@angular/core";
import { Signature, DocumentState } from "../../store/document/state";
import { Store } from "@ngrx/store";
import { RootState } from "../../store/root";
import { SetSignature, ClearSignatures } from "../../store/document/actions";
import { Observable } from "rxjs";
import {
    distinctUntilChanged,
    tap,
    filter,
    withLatestFrom,
    share,
    map,
} from "rxjs/operators";
import { ValidityState } from "../../store/validity/state";
import { ConsultationProcess } from "../../data/model";

export class EsignViewInfo {
    constructor(
        public hasFields: boolean,
        public allSigned: boolean,
        public onFirstPage: boolean,
        public onLastPage: boolean,
        public canFinalize: boolean,
    ) {}
}

@Injectable()
export class EsignService {
    private static finishedSignpad: boolean;
    private static signpadSign: boolean;

    public esignView$: Observable<EsignViewInfo>;
    public documentLoaded$: Observable<DocumentState>;

    constructor(private store: Store<RootState>) {
        this.esignView$ = store.pipe(
            map((state) => {
                const docState = state.document;
                const allSigned = Object.keys(docState.signatures).every((id) =>
                    this.isSigned(docState.signatures[id]),
                );
                return new EsignViewInfo(
                    Object.keys(docState.signatures).length > 0,
                    allSigned,
                    docState.currentPage <= 1,
                    docState.currentPage >= docState.pageCount,
                    this.isFinalizeAllowed(
                        state.model.ConsultationProcess,
                        state.validity,
                    ),
                );
            }),
        );
        this.documentLoaded$ = store
            .select((s) => s.document.beingBuilt)
            .pipe(
                distinctUntilChanged(),
                filter((beingBuilt) => beingBuilt === false),
                withLatestFrom(store, (b, state) => state.document),
                share(),
            );
        // Fake subscription to keep distinctUntilChanged going
        this.documentLoaded$.subscribe((_) => _);
    }

    public reset(field: Signature): void {
        this.store.dispatch(new SetSignature(field.index, null));
    }

    public sign(field: Signature, image: any) {
        this.store.dispatch(new SetSignature(field.index, image));
    }

    public isSigned(field: Signature): boolean {
        return field.dataUrl != null;
    }

    public isFinalizeAllowed(
        cp: ConsultationProcess,
        validityRoot: ValidityState,
    ) {
        // Special case: QR sign where cp is undefined
        if (!cp) {
            return false;
        }
        //const allowedByApplications = cp.Protocol.Offers.every(offer => offer.Divisions.every(division => !division.Application || division.FinalizationAllowed !== false));
        const isValid =
            validityRoot.agent.valid &&
            validityRoot.attendants.valid &&
            validityRoot.customer.valid &&
            validityRoot.productPicker.valid &&
            validityRoot.occasion.valid &&
            validityRoot.analysis.valid;
        return cp && cp.Id && !cp.IsFinished && isValid; // && allowedByApplications; //FEGI-2176: deaktivierung von FEGI-282
    }

    public clearSignatures(): void {
        this.store.dispatch(new ClearSignatures());
    }

    public getSignatures(docState: DocumentState): string[] {
        const signatures = docState.signatures.map((field) => {
            return (field.dataUrl || "").split(",")[1];
        });
        return signatures;
    }
}
